export default __webpack_public_path__ + "static/media/megaphone.977971b3.png";